import { Typography } from 'antd';
import React from 'react';
import {
  FormConfigProps,
  FormStempContentProps,
  contentStyling,
} from '../../constants/constants';
import { DynamicFormField } from '../DynamicFormField';

export const learningSpaceRequirementsMarked: Record<string, FormConfigProps> =
  {
    appropriateLocation: {
      label: 'parenkama tinkama ugdymosi vieta klasėje',
      value: 'appropriateLocation',
    },
    adjustableHeightDesk: {
      label:
        'parenkamas reguliuojamo aukščio stalas su sėdimos ir stovimos padėties funkcija',
      value: 'adjustableHeightDesk',
    },
    activeSeatingChair: {
      label: 'parenkama aktyvaus sėdėjimo kėdė, gimnastikos kamuolys',
      value: 'activeSeatingChair',
    },
    individualWorkspace: {
      label: 'esant poreikiui pritaikoma individuali darbo vieta',
      value: 'individualWorkspace',
    },
    deskDivider: {
      label:
        'esant poreikiui pastatoma stalo pertvara ar naudojama dėmesio sutelkimo sienelė',
      value: 'deskDivider',
    },
    designatedGroupWorkSpace: {
      label: 'numatoma tinkama vieta darbui grupėse',
      value: 'designatedGroupWorkSpace',
    },
    sensoryBreaks: {
      label:
        'organizuojamos individualios / sensorinės pertraukos klasėje įrengtoje erdvėje',
      value: 'sensoryBreaks',
    },
    other: {
      label: 'kita:',
      value: 'other',
      isInput: true,
    },
  };

export const Block61 = React.memo(
  ({ form, currentStep }: FormStempContentProps) => {
    return (
      <div
        style={{
          ...contentStyling,
          display: currentStep === 9 ? 'block' : 'none',
        }}
      >
        <Typography.Title
          style={{ marginTop: 0, marginBottom: 34, fontWeight: 'normal' }}
          level={4}
        >
          Ugdymosi vietos ir (ar) aplinkos pritaikymas:
        </Typography.Title>
        <DynamicFormField
          formItemConfig={learningSpaceRequirementsMarked}
          formPathParams={['subject', 'block6', 'space']}
          form={form}
        />
      </div>
    );
  },
);
